export default {
  isLoading: false,
  listaSolicitantes: [],
  listaSolicitudesFiltrada: [],
  filtros: null,
  isOpenModalAgendar: false,
  gestionarSolicitudStatus: false,
  filtrosSolicitudes: null,
  selectedSolicitud: null,
  selectedSolicitudShow: null,
  connectionHub: null,
  schedulingData: null,
  listaCargos: [],
  listaHorizonteCitas: [],
  selectedTipoSolicitud: {
    Icon: "2", name: "Pendiente de agendamiento", column: "estadoSolicitud", value: { text: "aprobado", value: [2,5,10] }  
  },
  request: {
    "PsychologicalExams": [
      {
        "Id": "2090c976-8656-471a-89aa-771bb236c435",
        "RequestId": 102,
        "ExamId": 17,
        "AchsOfficeId": 2,
        "Code": "N91902-014",
        "ExamDescription": "BIOIMPEDANCIOMETRÍA (% DE GRASA) (3)",
        "ExamTypeId": 1,
        "ExamTypeDescription": "MÉDICO",
        "AchsOfficeCode": "Arica",
        "AchsOfficeDescription": "Arica"
      }
    ],
    "AdditionalExams": [
      {
        "Id": "ba2065fc-afaf-4e28-b989-9c4284dc73fc",
        "RequestId": 102,
        "ExamId": 203,
        "AchsOfficeId": 9,
        "Code": "SEL0001-03",
        "ExamDescription": "OPERATIVOS Y ADMINISTRATIVOS",
        "ExamTypeId": 2,
        "ExamTypeDescription": "PSICOLÓGICO",
        "AchsOfficeCode": "La Serena",
        "AchsOfficeDescription": "La Serena"
      }
    ],
    "Pools": [
      {
        "Id": "a4aad9b7-80b7-4d59-964e-ccb37096ff3c",
        "RequestId": 102,
        "PoolId": 21,
        "AchsOfficeId": 9,
        "Code": 21,
        "Description": "SILICE CRISTALIZADA (3)",
        "AchsOfficeCode": null,
        "AchsOfficeDescription": null
      }
    ],
    "Workers": [
      {
        "Id": "0c3e388e-a575-4ac2-babb-41e6f33e69f9",
        "DocumentNumber": "176255498",
        "Name": "Felipe",
        "Age": 27,
        "Phone": "123123123",
        "Mail": "felipeaf@asd.las",
        "SchedulingDate": null,
        "DocumentType": 0,
        "IsScheduling": false
      },
      {
        "Id": "27dbf128-0cec-4e00-8a1e-98a801f6aaef",
        "DocumentNumber": "123123123",
        "Name": "Prueba",
        "Age": 30,
        "Phone": "12312389",
        "Mail": "asdasd@asdasd.cl",
        "SchedulingDate": null,
        "DocumentType": 0,
        "IsScheduling": false
      }
    ],
    "Id": 102,
    "CreationDate": "2019-04-23T19:31:26.377",
    "ApprovalDate": null,
    "PetitionerRut": "17625549-8",
    "PetitionerName": "Felipe Gallardo",
    "AuthorizedRut": "17625549-8",
    "AuthorizedName": "Felipe Gallardo",
    "RequestTypeId": 2,
    "RequestTypeDescription": "PREOCUPACIONAL",
    "ProposalDate": "2019-04-24T04:00:00",
    "ProposalDateEnd": "2019-04-28T04:00:00",
    "WorkersQuota": 2,
    "WorkersPending": 0,
    "RequestStatusId": 0,
    "Comment": null,
    "RejectedDate": null,
    "Content": null,
    "CostCenter": "123123123",
    "WorkerPositionId": 12,
    "RejectComment": null,
    "CompanyRut": "70360100-6",
    "CompanyName": "ACHS",
    "RequestStatus": "INGRESADO"
  },
  dataSelected: null,
  dataGridCupos: [],
  hourRange: [],
};
